// extracted by mini-css-extract-plugin
export default {"button":"PlayPauseButton_button__ewVnE"};